<template>
  <div class="">
    <search-group title="" :btnOffset="18" :btnSpan="6" :multipleLines="true" :inline="true"  @search="findData" @clear="clearValue">
      <Row :gutter="16">
        <!--<Col span="1" class="zr-label">项目</Col>-->
        <Col span="6">
          <Select placeholder="状态" v-model="searchData.state">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in statusList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <!--<Col span="1" class="zr-label">是否在职</Col>-->
        <Col span="6">
          <Select placeholder="是否在职" v-model="searchData.departure">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in dimissionList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" placeholder="请输入姓名或手机号" v-model="searchData.nameOrPhone" @keyup.enter.native="findData" />
        </Col>
      </Row>
    </search-group>
  </div>
</template>
<script>
  // import SearchGroup from 'components/SearchGroup/index';

  export default {
    // name: "SearchList",
    components: {
       // SearchGroup
    },
    data() {
      return {
        statusList:[{text:'正常',value:1},{text:'锁定',value:4}],
        dimissionList:[{text:'在职',value:1},{text:'离职',value:0}],
        searchData: {
          state: '',
          departure: 1,
          nameOrPhone: ''
        },
      }
    },
    methods: {
      findData() {
        this.$emit('findData', this.searchData)
      },
      clearValue() {
        this.searchData={
          state: '',
          departure: 1,
          nameOrPhone: ''
        };
        this.$emit('clear')
      },
    },
    created() {
    }
  }
</script>
<style scoped>
  .flex {
    display: block;

  }
  .search-wrapper{
    padding: 24px  0 !important;

  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }

</style>
